// "use client";

// import React, { useCallback, useEffect, useRef, useState } from "react";

// /**
//  * SchoolLogoUploader
//  * - Accepts PNG/JPG/SVG/WebP via click, drag-drop, or paste
//  * - Shows a live preview
//  * - Lets the user set alignment (left/center/right) and width (px)
//  * - Emits a base64 data URL through onChange; alignment/width via callbacks
//  *
//  * Props:
//  * - value: string (dataURL) | ""           current logo (data URL)
//  * - onChange: (dataUrlOrEmpty) => void     called when new image is chosen or cleared
//  * - align: "left" | "center" | "right"
//  * - onAlignChange: (align) => void
//  * - width: number (px)
//  * - onWidthChange: (num) => void
//  */
// export default function SchoolLogoUploader({
//   value = "",
//   onChange = () => {},
//   align = "left",
//   onAlignChange = () => {},
//   width = 140,
//   onWidthChange = () => {},
// }) {
//   const [dragOver, setDragOver] = useState(false);
//   const inputRef = useRef(null);

//   const readFileAsDataURL = (file) =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => resolve(String(reader.result || ""));
//       reader.onerror = reject;
//       reader.readAsDataURL(file);
//     });

//   const acceptImage = async (file) => {
//     if (!file) return;
//     const okTypes = [
//       "image/png",
//       "image/jpeg",
//       "image/jpg",
//       "image/webp",
//       "image/svg+xml",
//     ];
//     if (!okTypes.includes(file.type)) {
//       alert("Please upload a PNG, JPG, SVG, or WebP image.");
//       return;
//     }
//     // ~3MB guard; logos should be tiny
//     if (file.size > 3 * 1024 * 1024) {
//       alert("Logo is too large (max ~3MB). Please compress and try again.");
//       return;
//     }
//     const dataUrl = await readFileAsDataURL(file);
//     onChange(dataUrl);
//     try {
//       localStorage.setItem("cb_header_logo_dataurl", dataUrl);
//     } catch {}
//   };

//   const onPick = async (e) => {
//     const f = e.target.files?.[0];
//     await acceptImage(f);
//     // clear the input so same file can be chosen again if needed
//     if (inputRef.current) inputRef.current.value = "";
//   };

//   const onDrop = async (e) => {
//     e.preventDefault();
//     setDragOver(false);
//     const f = e.dataTransfer.files?.[0];
//     await acceptImage(f);
//   };

//   const onPaste = useCallback(
//     async (e) => {
//       // allow pasting an image from clipboard
//       const items = e.clipboardData?.items || [];
//       for (const it of items) {
//         if (it.type?.startsWith("image/")) {
//           const f = it.getAsFile?.();
//           if (f) {
//             await acceptImage(f);
//             break;
//           }
//         }
//       }
//     },
//     [] // stable
//   );

//   useEffect(() => {
//     // Load any previously saved logo from localStorage
//     if (!value) {
//       try {
//         const saved = localStorage.getItem("cb_header_logo_dataurl");
//         if (saved) onChange(saved);
//       } catch {}
//     }
//   }, []); // eslint-disable-line

//   return (
//     <div className="rounded-xl border border-slate-200/80 bg-white/80 p-4 shadow-sm">
//       <div
//         onDragOver={(e) => {
//           e.preventDefault();
//           setDragOver(true);
//         }}
//         onDragLeave={() => setDragOver(false)}
//         onDrop={onDrop}
//         onPaste={onPaste}
//         className={[
//           "relative flex flex-col items-center justify-center rounded-lg border-2 border-dashed p-6 transition",
//           dragOver
//             ? "border-indigo-400 bg-indigo-50/50"
//             : "border-slate-200 bg-slate-50/40 hover:bg-slate-50",
//         ].join(" ")}
//       >
//         {value ? (
//           <div className="w-full">
//             <div className="flex items-center justify-center">
//               {/* preview area (constrained by width control) */}
//               <img
//                 src={value}
//                 alt="School Logo Preview"
//                 className="object-contain"
//                 style={{ maxWidth: `${width}px`, maxHeight: 120 }}
//               />
//             </div>

//             <div className="mt-4 grid gap-3 sm:grid-cols-3">
//               <div className="sm:col-span-2">
//                 <label className="block text-[13px] font-semibold text-slate-800">
//                   Logo width (px)
//                 </label>
//                 <input
//                   type="range"
//                   min={60}
//                   max={300}
//                   step={5}
//                   value={width}
//                   onChange={(e) => onWidthChange(Number(e.target.value))}
//                   className="w-full accent-indigo-600"
//                 />
//                 <div className="mt-1 text-xs text-slate-600">
//                   Current: <b>{width}px</b> (height auto)
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-[13px] font-semibold text-slate-800">
//                   Alignment
//                 </label>
//                 <div className="mt-1 grid grid-cols-3 gap-1">
//                   {["left", "center", "right"].map((pos) => (
//                     <button
//                       key={pos}
//                       type="button"
//                       onClick={() => onAlignChange(pos)}
//                       className={[
//                         "rounded-md border px-2 py-1 text-sm",
//                         align === pos
//                           ? "border-indigo-500 bg-indigo-50 text-indigo-700"
//                           : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50",
//                       ].join(" ")}
//                     >
//                       {pos}
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <div className="mt-4 flex flex-wrap gap-2">
//               <button
//                 type="button"
//                 onClick={() => inputRef.current?.click()}
//                 className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50"
//               >
//                 Replace logo
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   onChange("");
//                   try {
//                     localStorage.removeItem("cb_header_logo_dataurl");
//                   } catch {}
//                 }}
//                 className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-1.5 text-sm font-semibold text-rose-700 hover:bg-rose-100"
//               >
//                 Remove
//               </button>
//             </div>
//           </div>
//         ) : (
//           <>
//             <p className="text-sm text-slate-600 text-center">
//               Drop a school logo here, paste from clipboard, or
//             </p>
//             <button
//               type="button"
//               onClick={() => inputRef.current?.click()}
//               className="mt-2 rounded-lg bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-indigo-300"
//             >
//               Choose an image
//             </button>
//           </>
//         )}

//         <input
//           ref={inputRef}
//           type="file"
//           accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml"
//           className="hidden"
//           onChange={onPick}
//         />
//       </div>

//       <p className="mt-2 text-xs text-slate-500">
//         Tip: Transparent PNGs look best. We’ll include the logo at the top of the PDF header. (.docx export won’t include the logo unless your server adds it there.)
//       </p>
//     </div>
//   );
// }


// app/components/SchoolLogoUploader.jsx
"use client";

import React, { useCallback, useEffect, useRef, useState } from "react";

/**
 * SchoolLogoUploader
 * - Accepts PNG/JPG/SVG/WebP via click, drag-drop, or paste
 * - Shows a live preview
 * - Lets the user set alignment (left/center/right) and width (px)
 * - Emits a base64 data URL through onChange; alignment/width via callbacks
 *
 * Props:
 * - value: string (dataURL) | ""
 * - onChange: (dataUrlOrEmpty) => void
 * - align: "left" | "center" | "right"
 * - onAlignChange: (align) => void
 * - width: number (px)
 * - onWidthChange: (num) => void
 */
export default function SchoolLogoUploader({
  value = "",
  onChange = () => {},
  align = "left",
  onAlignChange = () => {},
  width = 140,
  onWidthChange = () => {},
}) {
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef(null);

  // Clamp width safely whenever a parent passes a new value
  useEffect(() => {
    const clamped = Math.min(300, Math.max(60, Number(width) || 140));
    if (clamped !== width) onWidthChange(clamped);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  const readFileAsDataURL = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const acceptImage = async (file) => {
    if (!file) return;
    const okTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/webp",
      "image/svg+xml",
    ];
    if (!okTypes.includes(file.type)) {
      alert("Please upload a PNG, JPG, SVG, or WebP image.");
      return;
    }
    if (file.size > 3 * 1024 * 1024) {
      alert("Logo is too large (max ~3MB). Please compress and try again.");
      return;
    }
    const dataUrl = await readFileAsDataURL(file);
    onChange(dataUrl);
    try {
      localStorage.setItem("cb_header_logo_dataurl", dataUrl);
    } catch {}
  };

  const onPick = async (e) => {
    const f = e.target.files?.[0];
    await acceptImage(f);
    if (inputRef.current) inputRef.current.value = "";
  };

  const onDrop = async (e) => {
    e.preventDefault();
    setDragOver(false);
    const f = e.dataTransfer.files?.[0];
    await acceptImage(f);
  };

  const onPaste = useCallback(async (e) => {
    const items = e.clipboardData?.items || [];
    for (const it of items) {
      if (it.type?.startsWith("image/")) {
        const f = it.getAsFile?.();
        if (f) {
          await acceptImage(f);
          break;
        }
      }
    }
  }, []);

  useEffect(() => {
    if (!value) {
      try {
        const saved = localStorage.getItem("cb_header_logo_dataurl");
        if (saved) onChange(saved);
      } catch {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const justify = align === "center" ? "justify-center" : align === "right" ? "justify-end" : "justify-start";

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={onDrop}
        onPaste={onPaste}
        className={[
          "relative flex flex-col items-center justify-center rounded-lg border-2 border-dashed p-6 transition",
          dragOver ? "border-indigo-400 bg-indigo-50/50" : "border-gray-200 bg-gray-100 hover:bg-white",
        ].join(" ")}
        aria-label="Logo upload area"
      >
        {value ? (
          <div className="w-full">
            {/* Preview row honor alignment */}
            <div className={`flex ${justify} items-center`}>
              <img
                src={value}
                alt="School Logo Preview"
                loading="lazy"
                className="object-contain"
                style={{
                  // Fit rules: never exceed container, keep aspect ratio, respect chosen width
                  width: "100%",             // fill up to the maxWidth below
                  maxWidth: `${width}px`,     // requested width (clamped 60–300)
                  height: "auto",
                  maxHeight: 120,
                }}
              />
            </div>

            <div className="mt-4 grid gap-3 sm:grid-cols-3">
              {/* Width control */}
              <div className="sm:col-span-2">
                <label className="block text-[13px] font-semibold text-slate-800">
                  Logo width (px)
                </label>
                <input
                  type="range"
                  min={60}
                  max={300}
                  step={5}
                  value={width}
                  onChange={(e) => onWidthChange(Math.min(300, Math.max(60, Number(e.target.value))))}
                  className="w-full accent-indigo-600"
                  aria-label="Logo width"
                />
                <div className="mt-1 text-xs text-gray-700">
                  Current: <b>{width}px</b> (height auto)
                </div>
              </div>

              {/* Alignment control */}
              <div>
                <label className="block text-[13px] font-semibold text-slate-800">
                  Alignment
                </label>
                <div className="mt-1 grid grid-cols-3 gap-1">
                  {["left", "center", "right"].map((pos) => (
                    <button
                      key={pos}
                      type="button"
                      onClick={() => onAlignChange(pos)}
                      className={[
                        "rounded-md border px-2 py-1 text-sm transition",
                        align === pos
                          ? "border-indigo-500 bg-indigo-50 text-indigo-700"
                          : "border-gray-200 bg-white text-gray-700 hover:bg-gray-100",
                      ].join(" ")}
                      aria-pressed={align === pos}
                      aria-label={`Set alignment ${pos}`}
                    >
                      {pos}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="mt-4 flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => inputRef.current?.click()}
                className="rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-100"
              >
                Replace logo
              </button>
              <button
                type="button"
                onClick={() => {
                  onChange("");
                  try {
                    localStorage.removeItem("cb_header_logo_dataurl");
                  } catch {}
                }}
                className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-1.5 text-sm font-semibold text-rose-700 hover:bg-rose-100"
              >
                Remove
              </button>
            </div>
          </div>
        ) : (
          <>
            <p className="text-sm text-gray-700 text-center">
              Drop a school logo here, paste from clipboard, or
            </p>
            <button
              type="button"
              onClick={() => inputRef.current?.click()}
              className="mt-2 rounded-lg bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-indigo-300"
            >
              Choose an image
            </button>
          </>
        )}

        <input
          ref={inputRef}
          type="file"
          accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml"
          className="hidden"
          onChange={onPick}
          aria-label="Upload logo file"
        />
      </div>

      <p className="mt-2 text-xs text-gray-500">
        Tip: Transparent PNGs look best. The logo appears in the PDF header. (.docx export may omit the logo unless your server injects it.)
      </p>
    </div>
  );
}
